export const Data = [
    {
        id: 1,
        title: 'Web/App Development',
        icon: require('./assets/web-development.svg'),
        certificate: ['Web Development Bootcamp', 'Zero To Mastery(React.js)', 'Android Development Training(CU)'],
        expertise: ['React.js', 'Node.js', 'JavaScript', 'Typescript', 'SASS', 'CSS3', 'Java', 'XML']
    },
    {
        id: 2,
        title: 'Programming Language',
        icon: require('./assets/code.svg'),
        certificate: ['Google crash Course on Python', 'Pyhton for EveryBody', 'Joy of Computing With Pyhton'],
        expertise: ['Pyhton', 'Java', 'C++ *fundamentals']
    },
    {
        id: 3,
        title: 'Information Security',
        icon: require('./assets/hacker.svg'),
        certificate: ['Coming Soon'],
        expertise: ['Coming Soon']
    },
    {
        id: 4,
        title: 'Machine Learning',
        icon: require('./assets/Machine.svg'),
        certificate: ['Machine Learning with Python(IBM)', 'Machine Learning Training(Internsala)'],
        expertise: ['Fundamentals', '*Currently not very much interested in ML but definetly looking forward']
    },
    {
        id: 5,
        title: 'Cloud Computing',
        icon: require('./assets/cloud-computing.svg'),
        certificate: ['Coming Soon'],
        expertise: ['Coming Soon']
    },
]
export const Hobby = [
    {
        id: 1,
        title: 'Swimming',
        icon: require('./assets/swimming.svg'),
        about: 'I am a four times Gold Medal winner in my club'
    },
    {
        id: 2,
        title: 'Fitness',
        icon: require('./assets/bodybuilding.svg'),
        about: 'I lost 25kg in a year'
    },
    {
        id: 3,
        title: 'Netflix&Chill',
        icon: require('./assets/netflix.svg'),
        about: "That's one of my fav thing to do"
    }
]
export const SocialData=[
    {
        id: 1,
        title: 'Facebook',
        link: 'https://www.facebook.com/sy0837',
        icon: require('./assets/facebook.svg')
    },
    {
        id: 2,
        title: 'Instagram',
        link: 'https://www.instagram.com/sy0837',
        icon: require('./assets/insta.svg')
    },
    {
        id: 3,
        title: 'Twitter',
        link: 'https://twitter.com/sy08375',
        icon: require('./assets/twitter.svg')
    },
    {
        id: 4,
        title: 'LinkedIn',
        link: 'https://www.linkedin.com/in/sumit-yadav-0837/',
        icon: require('./assets/linkedin.svg')
    },
    {
        id: 5,
        title: 'Github',
        link: 'https://github.com/sy0837',
        icon: require('./assets/github.svg')
    },
]